(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_jatka-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jatka-product-tabs')) {
    customElements.define('jatka-product-tabs', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-pdp-tab]');
          if (!tab || !this.contains(tab)) return;
          event.preventDefault();
          this.select(tab.dataset.pdpTab);
        });
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-pdp-tab]');
          if (!tab) return;
          const tabs = [...this.querySelectorAll('[data-pdp-tab]')];
          let index = tabs.indexOf(tab);
          if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = tabs.length - 1;
          else if (event.key === ' ') { event.preventDefault(); this.select(tab.dataset.pdpTab); return; }
          else return;
          event.preventDefault();
          this.select(tabs[index].dataset.pdpTab);
          tabs[index].focus();
        });
      }
      connectedCallback() {
        const tabs = [...this.querySelectorAll('[data-pdp-tab]')];
        if (!tabs.length) return;
        this.querySelector('nav').setAttribute('role', 'tablist');
        for (const tab of tabs) {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.hash.slice(1));
        }
        for (const panel of this.querySelectorAll('[data-pdp-panel]')) {
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
        }
        this.dataset.enhanced = 'true';
        const hashTab = tabs.find(tab => tab.hash === window.location.hash);
        this.select(hashTab?.dataset.pdpTab || tabs[0].dataset.pdpTab);
      }
      select(key) {
        for (const tab of this.querySelectorAll('[data-pdp-tab]')) {
          const selected = tab.dataset.pdpTab === key;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        }
        for (const panel of this.querySelectorAll('[data-pdp-panel]')) panel.hidden = panel.dataset.pdpPanel !== key;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jatka-google-summary"] && !Shopify.designMode) return;
  try {
    // Judge.me stores its slide translation in pixels. Keep the selected card
  // aligned when the container changes width, including device rotation.
  function alignGoogleReviewsOnResize() {
    document.querySelectorAll('.section-content-wrapper:has(> .jatka-google-summary)').forEach((section) => {
      const app = section.querySelector('.shopify-app-block');
      if (!app || app.dataset.googleReviewsResizeBound) return;
      app.dataset.googleReviewsResizeBound = 'true';
      let previousWidth = 0;
      const align = (force = false) => {
        const track = app.querySelector('.jdgm-videos-container');
        const active = track?.querySelector('.jdgm-card.active');
        if (!active) return;
        const width = app.getBoundingClientRect().width;
        if (!force && Math.abs(width - previousWidth) < 0.5) return;
        previousWidth = width;
        requestAnimationFrame(() => {
          const selected = track.querySelector('.jdgm-card.active');
          if (!selected) return;
          const transition = track.style.transition;
          track.style.transition = 'none';
          track.style.transform = `translateX(-${selected.offsetLeft}px)`;
          requestAnimationFrame(() => { track.style.transition = transition; });
        });
      };
      const resize = new ResizeObserver(() => align());
      resize.observe(app);
      // Judge.me adds loop clones after the first card becomes active.
      // Wait for the complete track before correcting the initial offset.
      const ready = new MutationObserver(() => {
        if (app.querySelector('.jdgm-card.active') && app.querySelector('.jdgm-clone-before')) {
          requestAnimationFrame(() => requestAnimationFrame(() => align(true)));
          ready.disconnect();
        }
      });
      ready.observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      const visible = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) align(true);
      });
      visible.observe(app);
      align();
    });
  }
  alignGoogleReviewsOnResize();
  document.addEventListener('shopify:section:load', alignGoogleReviewsOnResize);
  } catch(e) { console.error(e); }
})();

})();
